<template>
  <div class="navbar-fixed">
    <b-navbar>
      <template #brand>
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <img :src="images.logo" />
        </b-navbar-item>
        <router-link class="CyR" :to="{ name: 'cotiza' }">Cotiza</router-link>
        <router-link class="CyR" :to="{ name: 'refiere' }">Refiere</router-link>
        <router-link
          :to="{ name: 'notificaciones' }"
          class="navbar-notification"
        >
          <span class="navbar-notification__cant">{{ notifications }}</span>
          <font-awesome-icon :icon="['fa', 'bell']" size="2x" />
        </router-link>
      </template>
      <template #start>
        <router-link :to="{ name: 'beneficios' }">Beneficios</router-link>
        <router-link :to="{ name: 'novedades' }">Novedades</router-link>
        <router-link :to="{ name: 'ayuda' }">Ayuda</router-link>
        <router-link :to="{ name: 'notificaciones' }"
          >Notificaciones</router-link
        >
      </template>

      <template #end>
        <b-navbar-item tag="div">
          <div class="btn-cr">
            <router-link :to="{ name: 'cotiza' }">Cotiza</router-link>
            <router-link :to="{ name: 'refiere' }">Refiere</router-link>
          </div>
          <div class="isDesktop">
            <h4>
              Hola {{ userLogin.nombres }}
              <router-link :to="{ name: 'mis-datos' }">
                <font-awesome-icon :icon="['fa', 'edit']"
              /></router-link>
            </h4>
          </div>
          <router-link
            :to="{ name: 'notificaciones' }"
            class="navbar-notification"
          >
            <span class="navbar-notification__cant">{{ notifications }}</span>
            <font-awesome-icon :icon="['fa', 'bell']" size="2x" />
          </router-link>
          <a class="logOut__btn" @click="onLogout">
            Salir <font-awesome-icon :icon="['fa', 'sign-out-alt']"
          /></a>
        </b-navbar-item>
      </template>
    </b-navbar>
    <div class="navbar isMobile">
      <h4>
        Hola {{ userLogin.nombres }}
        <router-link :to="{ name: 'mis-datos' }"
          ><font-awesome-icon :icon="['fa', 'edit']"
        /></router-link>
      </h4>
      <a @click="onLogout">
        Salir <font-awesome-icon :icon="['fa', 'sign-out-alt']"
      /></a>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import { GET_NOTIFICACIONES } from "@/core/services/store/notificacion.module";
import { LOGOUT } from "@/core/services/store/auth.module";
export default {
  data() {
    return {
      userLogin: this.$store.state.auth.user,
      images: {
        logo: process.env.BASE_URL + "./media/logo-bricsa-blanco.png",
      },
    };
  },
  mounted() {
    this.getNotificaciones();
  },
  methods: {
    onLogout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() => 
          location.href='http://www.bricsa.cl'
          //this.$router.push({ name: "login" })
        );
    },
    getNotificaciones() {
      this.$Progress.start();
      this.$store.dispatch(GET_NOTIFICACIONES, null).then(() => {
        this.$Progress.finish();
      });
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      notificaciones: (state) => state.notificacion.notificaciones,
    }),
    ...mapGetters(["layoutConfig", "getClasses"]),
    notifications: function () {
      if (typeof this.notificaciones.notificaciones == "undefined") return 0;
      return this.notificaciones.totalNoLeidas;
    },
    /**
     * Get header logo
     * @returns {string}
     */
    headerLogo() {
      return process.env.BASE_URL + this.layoutConfig("self.logo.sticky");
    },

    /**
     * Get classes for mobile header
     * @returns {null|*}
     */
    headerClasses() {
      const classes = this.getClasses("header_mobile");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
  },
};
</script>

<style lang="scss" scope>
.carousel-item {
  display: block;
}
.isDesktop {
  display: flex;
  justify-content: space-between;
  color: #fff;
  @media screen and (max-width: 1025px) {
    display: none !important;
  }
  h4 {
    a {
      margin-left: 10px;
    }
  }
}
.logOut__btn {
  margin-left: 30px;
  font-size: 20px;
  font-weight: bold;
  color: #fff;
}
.isMobile {
  display: none !important;
  @media screen and (max-width: 1025px) {
    justify-content: space-between;
    display: flex !important;
    width: 100%;
  }
  a {
    font-size: 20px;
    font-weight: bold;
  }
  h4 {
    text-align: left;
  }
}
.navbar-fixed {
  @media screen and (max-width: 1025px) {
    position: fixed;
    width: 100%;
    z-index: 100;
  }
}
.navbar {
  padding: 20px 7.5%;
  background-color: var(--bricsa-red) !important;
  color: #fff;
  @media screen and (max-width: 1025px) {
    padding: 10px 7.5% !important;
  }
  .navbar-brand {
    @media screen and (max-width: 1025px) {
      width: 100%;
      grid-template-columns: 28% 18% 18% 10% 14%;
      display: grid;
      justify-content: space-between;
      align-items: center;
    }
    .navbar-item {
      @media screen and (max-width: 1025px) {
        padding: 0;
      }
    }
    .navbar-notification {
      display: none;
      @media screen and (max-width: 1025px) {
        display: flex;
      }
    }
    .CyR {
      display: none;
      @media screen and (max-width: 1025px) {
        display: block;
        color: #fff;
        border: solid 1px #fff;
        font-size: 12px;
        padding: 7px 10px;
        text-align: center;
      }
    }
    .navbar-burger {
      color: #fff;
      span {
        height: 2px;
      }
    }
  }
  .navbar-menu {
    width: 100%;
    background-color: var(--bricsa-red);
  }
  .navbar-start {
    width: 80%;
    display: grid;
    grid-template-columns: repeat(4, max-content);
    column-gap: 15px;
    align-items: center;
    justify-content: flex-end;
    margin-right: 30px;
    @media screen and (max-width: 1025px) {
      grid-template-columns: 100%;
      justify-content: center;
      row-gap: 5px;
    }
    a {
      color: #fff;
      transition: 400ms;
      padding: 10px 15px;
      @media screen and (max-width: 1025px) {
        background-color: var(--bricsa-red);
        width: 100%;
        text-align: left;
        justify-self: center;
        padding: 5px 20px;
      }
      &:hover {
        background-color: var(--bricsa-red-dark) !important;
        color: #fff;
      }
    }
  }
  .navbar-end {
    width: 100%;
    .navbar-item {
      width: 100%;
      justify-content: space-between;
      @media screen and (max-width: 1025px) {
        display: none;
        justify-content: center;
        row-gap: 5px;
      }
      .btn-cr {
        a {
          padding: 10px 15px;
          margin-right: 10px;
          background-color: var(--bricsa-red);
          border-radius: 0;
          color: #fff;
          border-width: 2px;
          border: solid 1px #fff !important;
          transition: 400ms;
          &:hover {
            background-color: var(--bricsa-red-dark);
          }
        }
      }
    }
  }
  h4 {
    a {
      color: #fff;
    }
    font-size: 20px;
    font-weight: bold;
  }

  .navbar-notification {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    border: none;
    transition: 400ms;
    &:focus {
      border-color: var(--bricsa-red);
      box-shadow: none !important;
    }
    &:hover {
      filter: brightness(0.9);
    }
    span {
      top: -10px;
      text-align: center;
      right: -10px;
      background: #fff;
      border-radius: 100%;
      width: 25px;
      height: 25px;
      position: absolute;
      font-size: 16px;
      font-weight: bold;
      color: var(--bricsa-red);
      -webkit-box-shadow: -5px 5px 10px -5px rgba(0, 0, 0, 0.22);
      box-shadow: -5px 5px 10px -5px rgba(0, 0, 0, 0.22);
    }
    svg {
      color: #fff;
    }
  }
}
</style>
